import React, { useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
// import Modal from "react-responsive-modal";
import Modal from 'react-modal';
import { setStoreCloseModal } from "../../redux/features/store";
import Konsole from "../../utils/konsole/Konsole";
import { CheckStoreWebOpen } from "../../utils/Store/StoreCheck";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
const StoreClose = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const reduxData = useSelector((state: any) => state?.store);

    // Konsole.log('reduxDataStoreClose', reduxData)

  

    const handleModalClose = () => {
       // @@ close store message close
        dispatch(setStoreCloseModal(false))

        // @@ if checkout page redirect to home
         const pageName = window.location.pathname
        if(pageName == "/checkout"){
            navigate("/")
        }
    };

    let isStoreWebOpen = CheckStoreWebOpen(reduxData?.selectedStore);

    const returnMsg = useMemo(() => {
          
        return isStoreWebOpen ? t("Home.theStoreIsCurrentlyNotAccepting") : (reduxData?.storeDeliveryPickupType?.isPickupNDelivery) ? t("Home.theStoreIsCurrentlyClosed") : t("Home.currentlyWeDoNotProvideAnyService")
    }, [isStoreWebOpen, reduxData])

    return (
        <>
            {/* Modal for store closed message */}
            <Modal

             className="not-store-open w-auto bg-white p-0 md:h-[35rem] md:!rounded-md  overflow-hidden"
            onRequestClose={handleModalClose}
            isOpen={reduxData?.isStoreCloseModalOpen}

                // open={reduxData?.isStoreCloseModalOpen}
                // onClose={handleModalClose}
                // closeOnOverlayClick={false}
                // center
                // classNames={{
                //     overlay: "customOverlay",
                //     modal: "customModalClosed",
                //     closeIcon: "store-close-modal-icon",
                // }}
                // styles={{
                //     modal: {
                //         // width: "350px", // Adjusted for a compact size
                //         height: "auto",
                //         padding: "20px",
                //         borderRadius: "8px", // Rounded corners for a smoother look
                //         textAlign: "center", // Center the content
                //         position: "relative",
                //     },
                // }}
            >
                <div className="modal-content-closed mt-3">
                    {/* Title */}
                    {/* <h3>We&apos;re Sorry, {returnMsg} </h3> */}
                    <h3>{returnMsg} </h3>

                    {/* Information Message */}
                    {/* <p>
            Our store is currently closed for the day. We apologize for any
            inconvenience this may cause.
          </p> */}
                    {/* <p> Please check back during our regular operating hours. Our usual hours are:  </p>
          <ul>
            <li>Monday - Friday: 9:00 AM - 6:00 PM</li>
            <li>Saturday: 10:00 AM - 4:00 PM</li>
            <li>Sunday: Closed</li>
          </ul> */}

                    {/* <p>
            If you have any urgent inquiries, please feel free to contact our
            customer support at{" "}
            <a href="mailto:support@example.com">support@example.com</a> or call
            us at (123) 456-7890.
          </p> */}

                    {/* Close Button */}
                    <div style={{ marginTop: "20px" }}>

                        <button onClick={handleModalClose} className="bgBlue text-white text-center rounded-lg px-6 py-2 w-50 font-bold text-base">
                            {t("Home.close")}
                        </button>

                    </div>
                </div>
            </Modal>
        </>
    );
};

export default StoreClose;
